import {
  IconLayoutGrid,
  IconLayers,
  IconUsers,
  IconShield,
  IconPackage,
} from '../components/Icons';
import { PERMISSIONS, ROLES } from './rbac';

export const navSections = [
  {
    label: 'Overview',
    items: [
      {
        to: '/',
        label: 'Dashboard',
        end: true,
        Icon: IconLayoutGrid,
        permission: PERMISSIONS.DASHBOARD_VIEW,
      },
    ],
  },
  {
    label: 'Platform',
    roles: [ROLES.SUPER_ADMIN],
    items: [
      {
        to: '/brands',
        label: 'Brands',
        Icon: IconPackage,
        permission: PERMISSIONS.BRANDS_VIEW,
        roles: [ROLES.SUPER_ADMIN],
      },
    ],
  },
  {
    label: 'Operations',
    items: [
      {
        to: '/coupons',
        label: 'Coupons',
        Icon: IconLayers,
        permission: PERMISSIONS.VERIFICATION_VIEW,
      },
      {
        to: '/verifications',
        label: 'Verifications',
        Icon: IconShield,
        permission: PERMISSIONS.VERIFICATION_VIEW,
      },
    ],
  },
  {
    label: 'System',
    items: [
      {
        to: '/settings',
        label: 'Settings',
        Icon: IconUsers,
        permission: PERMISSIONS.SETTINGS_VIEW,
      },
    ],
  },
];
